import {
  Card,
  Col,
  Input,
  Row,
  Table,
  Button,
  Pagination,
  Select,
  Spin,
  App,
  Tooltip,
  Tag,
  Avatar
} from "antd";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { REPEAT_OFFENDER_DASHBOARD, DOWNLOAD_OFFENDER_REPORT, REPEAT_OFFENDER_SUMMARY } from "../../apis/apis";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { LoadingOutlined, DownloadOutlined, BarChartOutlined, FileExclamationOutlined, MailOutlined, ClockCircleOutlined, ExclamationCircleOutlined, WarningOutlined, RiseOutlined } from "@ant-design/icons";
import { formatToIST } from "../../../helper/CommonHelper";

const { Option } = Select;

function Offender() {
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [paginationLoader, setPaginationLoader] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [searchKey, setSearchKey] = useState(
    localStorage.getItem("offender_search_key") || "name"
  );

  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("offender_search") || ""
  );
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("offender_page")) || 1
  );
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const debounceRef = useRef(null);

  // OFFENDER LIST states
  const [total_offenders, set_total_offenders] = useState("");
  const [total_offences, set_total_offences] = useState("");
  const [high_risk_count, set_high_risk_count] = useState("");
  const [medium_risk_count, set_medium_risk_count] = useState("");


  const LIST_API = async (
    page = currentPage,
    per_page = pageSize,
    key = searchKey,
    value = searchValue
  ) => {

    const FORM_DATA = new FormData();

    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", per_page);

    if (value) {
      FORM_DATA.append(key, value);
    }

    try {
      const API_CALL = await REPEAT_OFFENDER_DASHBOARD(FORM_DATA);

      if (API_CALL?.data?.status) {
        set_table_data(API_CALL?.data?.data || []);
        setCurrentPage(API_CALL?.data?.current_page ?? page);

        const total = API_CALL?.data?.total_records;
        setTotalItems(total != null ? total : 0);
      }
    } catch (err) {
      console.error(err);
    }

    setLoader(false);
    setPaginationLoader(false);
  };
  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("offender_page")) || 1,
      pageSize,
      localStorage.getItem("offender_search_key") || "name",
      localStorage.getItem("offender_search") || ""
    );
  }, []);

  const DOWNLOAD_OFFENDER_REPORT_ACTION = async (email) => {
    const formData = new FormData();
    formData.append("email", email);

    const API_CALL = await DOWNLOAD_OFFENDER_REPORT(formData);
    if (API_CALL?.data?.status) {
      notification.success({
        message: "Successful",
        description: "Check the Download tab for your report",
      });
    }
  };

  const handleSearch = (e) => {

    const value = e.target.value;

    if (value && !searchValue) {
      localStorage.setItem(
        "offender_last_search_page",
        currentPage
      );
    }

    setSearchValue(value);

    localStorage.setItem(
      "offender_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "offender_last_search_page"
          )
        ) || 1;

      setCurrentPage(pageToLoad);

      LIST_API(
        pageToLoad,
        pageSize,
        searchKey,
        value
      );

    }, 500);
  };


  const onPageChange = (page) => {

    localStorage.setItem(
      "offender_page",
      page
    );

    setPaginationLoader(true);

    LIST_API(
      page,
      pageSize,
      searchKey,
      searchValue
    );
  };

  const onPageSizeChange = (value) => {

    localStorage.setItem(
      "offender_page",
      1
    );

    setPageSize(value);

    LIST_API(
      1,
      value,
      searchKey,
      searchValue
    );
  };


  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      render: (text, record) => {
        const initials = text
          ? text
            .split(" ")
            .slice(0, 2)
            .map((word) => word[0])
            .join("")
            .toUpperCase()
          : "";

        const colors = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae"];
        const color = text ? colors[text.length % colors.length] : colors[0];

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Avatar style={{ backgroundColor: color }}>
              {initials}
            </Avatar>

            <div>
              <div style={{ fontWeight: 500 }}>{text}</div>
              <span style={{ color: "gray", fontSize: "12px" }}>
                {record.email}
              </span>
            </div>
          </div>
        );
      },
    },
    {
  title: "DEPARTMENT",
  dataIndex: "department",
  render: (val) => {
    if (
      val === null ||
      val === undefined ||
      val === "" ||
      val === "null" ||
      val === "NaN" ||
      val === "nan"
    ) {
      return "Unassigned";
    }

    return val;
  },
},
    {
      title: "OFFENCE",
      dataIndex: "total_campaign",
      render: (val) => val ?? "0",
    },
    {
      title: "OFFENSE TYPES",
      dataIndex: "offense_type",
      render: (types) => {
        if (!types || types.length === 0) return "No Data";

        return types.map((type, index) => {
          let color = "default";

          if (type === "Clicked Link") color = "blue";
          if (type === "Submitted Data") color = "red";
          if (type === "Opened Email") color = "gold";

          return (
            <Tag color={color} key={index}>
              {type}
            </Tag>
          );
        });
      },
    },
    {
      title: "RISK LEVEL",
      dataIndex: "risk_level",
      render: (risk) => {
        if (!risk) return "No Data";

        let color = "default";

        if (risk === "High Risk") color = "red";
        else if (risk === "Medium Risk") color = "orange";
        else if (risk === "Low Risk") color = "green";

        return <Tag color={color}>{risk}</Tag>;
      },
    },
    {
      title: "LAST OFFENCE",
      dataIndex: "last_offence",
      render: (_, record) => formatToIST(record?.last_offence),
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <Tooltip title="Campaign Details">
            <Button
              size="small"
              type="primary"
              onClick={() => {

                localStorage.setItem(
                  "offender_page",
                  currentPage
                );

                localStorage.setItem(
                  "offender_search",
                  searchValue
                );

                localStorage.setItem(
                  "offender_search_key",
                  searchKey
                );

                navigate(
                  `/offender-camp-details/${btoa(record.email)}`
                );
              }}
              style={{ marginRight: "12px" }}
            >
              <BarChartOutlined />
            </Button>
          </Tooltip>
          <Tooltip title=" Download">
            <Button onClick={() => DOWNLOAD_OFFENDER_REPORT_ACTION(record?.email)} variant="solid" size="small" style={{ backgroundColor: "#1fa7a1", color: "#ffffff" }}>
              <DownloadOutlined />
            </Button></Tooltip>
        </>
      ),
    },
  ];

  //OFFENDER SUMMARY CARDS

  const REPEAT_OFFENDER_SUMMARY_LIST = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await REPEAT_OFFENDER_SUMMARY(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_high_risk_count(API_CALL?.data?.high_risk_count);
      set_total_offenders(API_CALL?.data?.total_offenders);
      set_total_offences(API_CALL?.data?.total_offences);
      set_medium_risk_count(API_CALL?.data?.medium_risk_count);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };


  useEffect(() => {
    REPEAT_OFFENDER_SUMMARY_LIST();
  }, []);


  return (
    <div className="lms-body">


      <Row>
        <Col span={12}>
          <h1 style={{ margin: "0px", padding: "0px" }}>Offender List</h1>
          <span style={{ color: "gray", fontSize: "16px", fontWeight: "600" }}>
            Track repeat phishing simulation offenders
          </span>
        </Col>

      </Row>


      <Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px"

                }}
              >
                <WarningOutlined style={{ color: "#8c3add", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_offenders}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Offenders
                </span>
              </div>
            </div>


          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",

            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#d1fae5",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px"

                }}
              >
                <ExclamationCircleOutlined style={{ color: "#1fa7a1", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{high_risk_count}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  High Risk                </span>
              </div>
            </div>


          </Card>
        </Col>

        {/* Insider Risk */}
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#fee2e2",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px"

                }}
              >
                <RiseOutlined style={{ color: "red", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{medium_risk_count}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Medium Risk
                </span>
              </div>
            </div>


          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}

          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#fee2e2",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px"
                }}
              >
                <ClockCircleOutlined style={{ color: "red", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_offences}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Offenses
                </span>
              </div>
            </div>


          </Card>
        </Col>
      </Row>


      <Card style={{ marginTop: "15px" }}>

        <Row style={{ marginBottom: "15px" }}>
          <Col span={12}>
            <Input
              addonBefore={
                <Select
                  defaultValue="name"
                  value={searchKey}
                  onChange={(v) => {

                    setSearchKey(v);

                    localStorage.setItem(
                      "offender_search_key",
                      v
                    );

                    LIST_API(
                      currentPage,
                      pageSize,
                      v,
                      searchValue
                    );
                  }}
                >
                  <Option value="name">Name</Option>
                  <Option value="email">Email</Option>
                </Select>
              }
              placeholder={`Search by ${searchKey}`}
              onChange={handleSearch}
              value={searchValue}
              size="large"
            />
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : (
          <>
            {paginationLoader ? (
              <div style={{ textAlign: "center", padding: "60px" }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : (
              <Table
                columns={columns}
                dataSource={table_data}
                pagination={false}
                rowKey="email"
                style={{ marginTop: "15px" }}
              />
            )}


            {table_data.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "15px",
                  marginTop: "20px",
                }}
              >
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={totalItems}
                  onChange={onPageChange}
                  showSizeChanger={false}
                />

                <Select
                  value={pageSize}
                  onChange={onPageSizeChange}
                  style={{ width: 120 }}
                  options={[
                    { value: 10, label: "10 / page" },
                    { value: 20, label: "20 / page" },
                    { value: 50, label: "50 / page" },
                    { value: 100, label: "100 / page" },
                  ]}
                />
              </div>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "red",
                  marginTop: "20px",
                }}
              ></div>
            )}
          </>
        )}
      </Card>


    </div>
  );
}

export default Offender;
